import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { bootstrapHubResource, hubHomeResource } from '../../../services/resources';
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import { HubHomeAsync } from '../../../ui';
import { HUB_STUDIO_HUBS_HOME_NAME, HUB_STUDIO_HUBS_HOME_PATH } from '../constants';
export var hubHomeRoute = {
  component: HubHomeAsync,
  exact: true,
  name: HUB_STUDIO_HUBS_HOME_NAME,
  resources: [bootstrapHubResource, hubHomeResource],
  path: HUB_STUDIO_HUBS_HOME_PATH
};
export var routes = [hubHomeRoute];
export var HUB_STUDIO_UFO_NAME_ROUTES_MAP = _defineProperty({}, HUB_STUDIO_HUBS_HOME_PATH, 'homeRoute');